import { render, staticRenderFns } from "./UserEditor.vue?vue&type=template&id=993609b0&scoped=true&"
import script from "./UserEditor.vue?vue&type=script&lang=ts&"
export * from "./UserEditor.vue?vue&type=script&lang=ts&"
import style0 from "./UserEditor.vue?vue&type=style&index=0&id=993609b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993609b0",
  null
  
)

export default component.exports